import React, { Component } from "react";
import { func, bool, string, shape, arrayOf } from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { Field, Form, withFormik } from "formik";
import Yup from "yup";

import { selectors as sessionSelectors } from "reducers/session";
import { actions as paymentsAFIPActions, selectors as paymentsAFIPSelectors } from "reducers/paymentsAFIP";

import Col from "react-bootstrap/lib/Col";
import MainContainer from "pages/_components/MainContainer";
import Container from "pages/_components/Container";
import { resizableRoute } from "pages/_components/Resizable";
import Button from "pages/_components/Button";
import PageLoading from "pages/_components/PageLoading";
import Head from "pages/_components/Head";
import Notification from "pages/_components/Notification";
import Productselector from "pages/forms/_components/_fields/Productselector";
import PaymentAFIPDetailContent from "pages/servicePayments/_components/PaymentAFIPDetailContent";
import { selectors as accountsSelector, actions as accountsActions } from "reducers/accounts";
import classNames from "classnames";
import * as i18n from "util/i18n";
import { getServicePaymentsPath } from "util/servicePaymentsRoutes";
import {
    applyEmbeddedV3ShellLayoutState,
    clearEmbeddedV3ShellLayoutState,
    isUxDashboardImprovementsEnabled,
} from "util/v3ShellLayoutSync";
import { push } from "react-router-redux";

const FORM_ID = "pay.paymentAFIP";

class PayPaymentAFIP extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        isDesktop: bool.isRequired,
        embeddedInV3Shell: bool,
        paymentAFIP: shape({}).isRequired,
        values: shape({
            debitAccount: string.isRequired,
        }).isRequired,
        accounts: arrayOf(
            shape({
                idProduct: string.isRequired,
            }),
        ).isRequired,
        fetching: bool.isRequired,
        isReturnFromDetail: bool.isRequired,
        redirect: bool.isRequired,
        loggedUser: shape({
            userId: string.isRequired,
        }).isRequired,
    };

    static defaultProps = {
        embeddedInV3Shell: false,
    };

    componentDidMount() {
        const { redirect, dispatch, accounts, loggedUser } = this.props;
        if (redirect) {
            dispatch(push(getServicePaymentsPath()));
        }
        if (accounts?.length <= 0) {
            dispatch(accountsActions.listAccounts(loggedUser.userId));
        }
        this.syncEmbeddedV3ShellLayout();
    }

    componentDidUpdate(prevProps) {
        const { embeddedInV3Shell, isDesktop, paymentAFIP } = this.props;
        if (
            embeddedInV3Shell &&
            (prevProps.embeddedInV3Shell !== embeddedInV3Shell ||
                prevProps.isDesktop !== isDesktop ||
                prevProps.paymentAFIP !== paymentAFIP)
        ) {
            this.syncEmbeddedV3ShellLayout();
        }
    }

    componentWillUnmount() {
        const { dispatch, embeddedInV3Shell } = this.props;
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch);
        }
    }

    syncEmbeddedV3ShellLayout = () => {
        const { dispatch, embeddedInV3Shell, isDesktop, paymentAFIP } = this.props;
        const numberVEP = paymentAFIP ? Number(paymentAFIP.numberVEP) : undefined;
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            scopes: ["paymentAFIP"],
            goBackPath: getServicePaymentsPath(),
            headerTitle: i18n.get("pay.paymentAFIP.title", null, { numberVEP }),
        });
    };

    handleGoBack = () => {
        const { dispatch, isReturnFromDetail } = this.props;
        dispatch(paymentsAFIPActions.setIsBackFromOtherPage(isReturnFromDetail));
    };

    centerContentMobile = () => {
        const { isDesktop, paymentAFIP } = this.props;

        const numberVEP = paymentAFIP ? Number(paymentAFIP.numberVEP) : undefined;

        if (!isDesktop) {
            return (
                <div className="title-account-header-multiline-background-blue">
                    <h1>{i18n.get("pay.paymentAFIP.title", null, { numberVEP })}</h1>
                </div>
            );
        }

        return (
            <div className="view-title d-flex">
                <h1>{i18n.get("pay.paymentAFIP.title", null, { numberVEP })}</h1>
            </div>
        );
    };

    render() {
        const { accounts, values, isDesktop, fetching, paymentAFIP, embeddedInV3Shell } = this.props;

        const { debitAccount } = values;

        const currencies = [{ id: 0, label: i18n.get(`currency.label.0`) }];

        const accountsToShow = accounts?.filter((account) => account.currency === currencies[0].id.toString());

        const debitAccountDefault = accountsToShow?.find((account) => account.favorite)?.idProduct;

        const showEmbeddedShellHeader = embeddedInV3Shell && isUxDashboardImprovementsEnabled() && !isDesktop;

        return (
            <>
                {!embeddedInV3Shell && <Notification scopeToShow="paymentAFIP" />}
                {!showEmbeddedShellHeader && (
                    <div className="admin-detail-head px-0">
                        <Head
                            onBack={this.handleGoBack}
                            headerClassName={!isDesktop ? "blue-main-header-mobile blue-main-title-mobile" : ""}
                            centerElement={isDesktop ? undefined : this.centerContentMobile}
                        />
                        {isDesktop && <Head centerElement={this.centerContentMobile} hasInlineButtons />}
                    </div>
                )}
                <PageLoading loading={fetching}>
                    <MainContainer>
                        <div className="above-the-fold">
                            <Form>
                                {paymentAFIP && (
                                    <PaymentAFIPDetailContent paymentAFIP={paymentAFIP} isDesktop={isDesktop} />
                                )}
                                <Container
                                    className={`container--layout align-items-center container-white ${isDesktop &&
                                        "mb-1 mt-2 with-padding"}`}
                                    gridClassName="form-content">
                                    <Col sm={12} md={10} lg={7} className="align-items-center">
                                        <Col sm={12} className={classNames({ "px-0": !isDesktop })}>
                                            <Field
                                                name="debitAccount"
                                                component={Productselector}
                                                idField="debitAccount"
                                                data={{
                                                    emptyOptionLabel: "",
                                                    options: accountsToShow,
                                                }}
                                                value={debitAccount || debitAccountDefault}
                                                isRequired
                                                mode="edit"
                                                labelText={`${FORM_ID}.debitAccount`}
                                                idForm={FORM_ID}
                                                isDesktop={isDesktop}
                                                customPlaceholder={i18n.get("transfers.productSelector.placeholder")}
                                                style={{ marginTop: 0 }}
                                            />
                                        </Col>
                                    </Col>
                                </Container>
                                {isDesktop ? (
                                    <Container className="flex-grow align-items-center" gridClassName="form-content">
                                        <Col sm={12} md={9} lg={4} className="mt-8">
                                            <Button
                                                type="submit"
                                                bsStyle="dark"
                                                label={`${FORM_ID}.button`}
                                                loading={fetching}
                                            />
                                        </Col>
                                    </Container>
                                ) : (
                                    <Container className="flex-grow align-items-center" gridClassName="form-content">
                                        <Col sm={12} className="align-items-center">
                                            <Button
                                                type="submit"
                                                bsStyle="dark"
                                                label={`${FORM_ID}.button`}
                                                loading={fetching}
                                                className="mt-6"
                                            />
                                        </Col>
                                    </Container>
                                )}
                            </Form>
                        </div>
                    </MainContainer>
                </PageLoading>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    loggedUser: sessionSelectors.getUser(state),
    accounts: accountsSelector.getAccounts(state),
    fetching: paymentsAFIPSelectors.getFetching(state),
    paymentAFIP: paymentsAFIPSelectors.getPaymentAFIP(state),
    isReturnFromDetail: paymentsAFIPSelectors.getIsReturnFromDetail(state),
    redirect: paymentsAFIPSelectors.getBackFromTicket(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        validateOnChange: true,
        validateOnBlur: false,
        mapPropsToValues: () => ({
            debitAccount: "",
        }),
        validationSchema: () =>
            Yup.lazy(() =>
                Yup.object().shape({
                    debitAccount: Yup.string().required(i18n.get(`${FORM_ID}.debitAccount.field.error.required`)),
                }),
            ),
        handleSubmit: ({ debitAccount }, formikBag) => {
            const { dispatch, accounts, paymentAFIP } = formikBag.props;
            const completeDebitAccount = accounts.find(({ idProduct }) => idProduct === debitAccount);

            dispatch(paymentsAFIPActions.payPaymentAFIPPreview(completeDebitAccount, paymentAFIP));
        },
    }),
    resizableRoute,
)(PayPaymentAFIP);
